import React, { useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { GetStationOutstangReport } from './function';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setStationID,
  setStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import { StationOutstangColumns } from './columns';
import { FormatNumber2 } from '../utility/component/tools';
import GeniusReportsDate from '../utility/component/reportDate';
import {
  setAlertWithTitle,
  setListStationMasterModalStatus,
} from '../utility/Redux/modal';
import ModListStationMaster from '../utility/component/modals/modListStationMaster';
import GeniusTableReports from '../utility/component/geniusComponents/geniusTableforReports';
import ReactToPrint from 'react-to-print';
import IsLocalData from '../utility/functions/ceckLocalData';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';
import {
  CalendarDays,
  FileText,
  MapPin,
  Printer,
  Search,
  TrendingDown,
  TrendingUp,
  WalletCards,
  X,
} from 'lucide-react';

const StationOutstanding = () => {
  const fromDate = useSelector(selectreportFromDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const toDate = useSelector(selectreportToDate);
  const [toDateFocus, setToDateFocus] = useState(false);
  const ReduxStation_id = useSelector(selectStationId);
  const ReduxStationName = useSelector(selectStationName);
  const userType = useSelector(selectUserType);
  const [list, setList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const printRef = useRef();
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);
  const okButton = () => {
    if (ReduxStation_id) {
      GetStationOutstangReport(
        prefix,
        dispatch,
        token,
        setList,
        fromDate,
        toDate,
        ReduxStation_id,
        ReduxStationName
      );
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'Please select station first',
        })
      );
    }
  };

  const columns = StationOutstangColumns(windowWidth);
  const filteredList = useMemo(() => {
    const query = searchTerm.trim().toLowerCase();
    if (!query) return list;

    return list.filter((row) =>
      [row.FNO, row.SID, row.DATE, row.OPENING_BALANCE]
        .filter((value) => value !== null && value !== undefined)
        .some((value) => String(value).toLowerCase().includes(query))
    );
  }, [list, searchTerm]);
  const totalCollection = list.reduce(
    (total, row) => Number(total) + Number(row.COLLECTION),
    0
  );

  const totalDebit = list.reduce(
    (total, row) => Number(total) + Number(row.DEBIT),
    0
  );

  const totalBalcence = list.reduce(
    (total, row) => Number(total) + Number(row.RUNNING_BALANCE),
    0
  );
  const totalNetCollection = list.reduce(
    (total, row) => Number(total) + Number(row.NET_COLLECTION),
    0
  );
  const totalNetDebit = list.reduce(
    (total, row) => Number(total) + Number(row.NET_DEBIT),
    0
  );

  useEffect(() => {
    const elseFunc = () => {
      if (userType !== 'USER') {
        dispatch(setStationID(''));
        dispatch(setStationName(''));
      }
    };

    const callback = (details, data) => {
      setList(data);
      dispatch(setStationID(details[0].SID));
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
      dispatch(setStationName(details[0].SNAME));
    };
    IsLocalData('Station_outstanding', callback, elseFunc);
  }, [dispatch, userType]);

  const StatCard = ({ icon: Icon, label, value, tone }) => (
    <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
      <div className="flex items-center gap-3">
        <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${tone}`}>
          <Icon size={19} strokeWidth={2} />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
            {label}
          </p>
          <p className="mt-0.5 truncate text-xl font-bold text-slate-900">{value}</p>
        </div>
      </div>
    </div>
  );

  const canSelectStation = ['MANAGER', 'ADMIN', 'STORE'].includes(userType);

  return (
    <div className="h-full overflow-auto bg-slate-50">
      <div className="mx-auto flex min-h-full w-full max-w-[1800px] flex-col gap-4 p-3 sm:p-5">
        <section className="overflow-visible rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col gap-4 border-b border-slate-100 px-5 py-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-700">
                <WalletCards size={22} />
              </div>
              <div>
                <h1 className="text-xl font-bold tracking-tight text-slate-900">
                  Station Outstanding
                </h1>
                <p className="mt-1 text-sm text-slate-500">
                  Track daily debit, collection and running balance for a station.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-600">
              <MapPin size={16} className="text-slate-400" />
              <span className="text-slate-500">Station:</span>
              <span className="max-w-[220px] truncate font-semibold text-slate-800">
                {ReduxStationName || ReduxStation_id || 'Not selected'}
              </span>
            </div>
          </div>

          <div className="grid gap-3 p-4 lg:grid-cols-[1fr_1fr_1.4fr_auto] lg:items-end">
            <div>
              <label className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
                <CalendarDays size={14} /> From date
              </label>
              <GeniusReportsDate
                date={fromDate}
                onChange={(date) => {
                  dispatch(setreportsFromDate(moment(date).format('YYYY-MM-DD')));
                  setFromDateFocus(false);
                }}
                dateFocus={fromDateFocus}
                SetDateFocus={setFromDateFocus}
              />
            </div>
            <div>
              <label className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
                <CalendarDays size={14} /> To date
              </label>
              <GeniusReportsDate
                date={toDate}
                onChange={(date) => {
                  dispatch(setreportsTodate(moment(date).format('YYYY-MM-DD')));
                  setToDateFocus(false);
                }}
                dateFocus={toDateFocus}
                SetDateFocus={setToDateFocus}
              />
            </div>
            <div>
              <label className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
                Station
              </label>
              <button
                type="button"
                disabled={!canSelectStation}
                onClick={() => dispatch(setListStationMasterModalStatus(true))}
                className="flex h-9 w-full items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 text-left text-sm transition hover:border-blue-400 disabled:cursor-default disabled:bg-slate-50"
              >
                <Search size={15} className="shrink-0 text-slate-400" />
                <span className="font-semibold text-slate-700">
                  {ReduxStation_id || 'Select'}
                </span>
                <span className="truncate text-slate-500">
                  {ReduxStationName || 'Choose a station'}
                </span>
              </button>
            </div>
            <button
              type="button"
              onClick={okButton}
              className="h-10 rounded-lg bg-blue-600 px-6 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700"
            >
              Run report
            </button>
          </div>
        </section>

        <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
          <StatCard icon={FileText} label="Records" value={list.length.toLocaleString()} tone="bg-slate-100 text-slate-600" />
          <StatCard icon={TrendingUp} label="Total debit" value={FormatNumber2(totalDebit)} tone="bg-rose-50 text-rose-600" />
          <StatCard icon={TrendingDown} label="Total collection" value={FormatNumber2(totalCollection)} tone="bg-emerald-50 text-emerald-600" />
          <StatCard icon={WalletCards} label="Running balance" value={FormatNumber2(totalBalcence)} tone="bg-amber-50 text-amber-700" />
        </section>

        <section className="flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col gap-3 border-b border-slate-200 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="font-semibold text-slate-900">Outstanding details</h2>
              <p className="text-xs text-slate-500">
                Daily station transactions for the selected period.
              </p>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row">
              <div className="relative">
                <Search size={17} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  placeholder="Search FNO, station or date"
                  className="h-10 w-full rounded-lg border border-slate-300 pl-9 pr-9 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 sm:w-64"
                />
                {searchTerm && (
                  <button type="button" onClick={() => setSearchTerm('')} aria-label="Clear search" className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">
                    <X size={16} />
                  </button>
                )}
              </div>
              {list.length > 0 && (
                <ReactToPrint
                  trigger={() => (
                    <button className="flex h-10 items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 text-sm font-semibold text-white transition hover:bg-slate-700">
                      <Printer size={16} /> Print report
                    </button>
                  )}
                  content={() => printRef.current}
                />
              )}
            </div>
          </div>

          <ReportDataTable
            rows={filteredList}
            columns={columns}
            getRowKey={(row) => row.id}
            emptyTitle={searchTerm ? 'No matching records' : 'No outstanding data found'}
            emptyDescription={
              searchTerm
                ? 'Try a different FNO, station or date.'
                : 'Select a station and date range, then run the report.'
            }
            footerValue={(column) => {
              if (column.field === 'DATE') return 'Grand Total';
              if (column.field === 'DEBIT') return FormatNumber2(totalDebit);
              if (column.field === 'COLLECTION') return FormatNumber2(totalCollection);
              if (column.field === 'NET_DEBIT') return FormatNumber2(totalNetDebit);
              if (column.field === 'NET_COLLECTION') return FormatNumber2(totalNetCollection);
              if (column.field === 'RUNNING_BALANCE') return FormatNumber2(totalBalcence);
              return '';
            }}
          />
        </section>

        <div className="hidden print:block">
        <div
          ref={printRef}
          className="w-full"
        >
          <GeniusTableReports
            stationId={`${ReduxStation_id} ${ReduxStationName}`}
            date={fromDate}
            date1={toDate}
            columns={columns}
            data={list}
            headerWidth={'80px'}
         
            Fotter={
              list[0] && (
                <div className="flex justify-end">
 <div
                  style={{
                    border: "1px solid #d1d5db",
                    borderRadius: 8,
                    padding: 12,
                    background: "#fafafa",
                  }}
                  className="mt-[10px] w-fit"
                >
                  <div
                    className="grid"
                    style={{
                      gridTemplateColumns: "repeat(2, 1fr)", // 👈 3 columns
                      gap: "10px",
                    }}
                  >
                    {[
                      { label: "Collection", value: totalCollection },
                      { label: "Debit", value: totalDebit },
                      { label: "Total Net Collectin", value: totalNetCollection },
                      { label: "Total Net Debit", value: totalNetDebit },
                    ].map((item, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className='w-fit' style={{ fontSize: 12, color: "#6b7280" ,}}>
                          {item.label}
                        </div>
            
                        <div className='ml-2' style={{ fontWeight: 600, textAlign: "right" }}>
                          {FormatNumber2(item.value)}
                        </div>
                      </div>
                    ))}
                  </div>
            
                  {/* Balance Highlight */}
                  <div
                    style={{
                      marginTop: 12,
                      borderTop: "1px solid #d1d5db",
                      paddingTop: 10,
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    <span>Total Running Bal.</span>
                    <span>{FormatNumber2(totalBalcence)}</span>
                  </div>
                </div>
                </div>
               
              )
            }
            title={'Station Outstanding'}
          />
        </div>
        </div>

      <ModListStationMaster
        onRowClick={(p) => {
          setList([]);
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      </div>
    </div>
  );
};

export default StationOutstanding;
